import { createStep } from './rocket-configs';
import { getSetupGuide } from '@/features/setup-guide/api';

export const AUTOMATE_WITH_CAMPAIGNS = [
  createStep({
    id: 'goal',
    ariaLabel: 'Choose a goal',
    content: 'Choose a goal',
    queryFn: getSetupGuide,
    completion: (data) => {
      if (data == null) {
        return 0;
      }
      if (data?.setup_guide.set_conversion_at != null || data?.setup_guide.campaign_rocket_added_goal_at != null) {
        return 1;
      }
      return 0;
    },
    modelId: 'campaign_rocket_added_goal_at',
    href: (setupGuide, currentPath) => {
      const params = `?ipf=goal`;
      if (currentPath?.includes('workflow/action') === true) {
        return `${currentPath}${params}`;
      }
      if (setupGuide?.sample_campaign_id == null) {
        return `campaigns/`;
      }
      return `campaigns/${setupGuide?.sample_campaign_id}/setup/workflow/actions${params}`;
    },
  }),
  createStep({
    id: 'email',
    ariaLabel: 'Edit an email',
    content: 'Edit an email',
    queryFn: getSetupGuide,
    completion: (data) => {
      if (data == null) {
        return 0;
      }
      if (data?.setup_guide.edited_email_at != null || data?.setup_guide.campaign_rocket_edited_email_at != null) {
        return 1;
      }
      return 0;
    },
    modelId: 'campaign_rocket_edited_email_at',
    href: (setupGuide, currentPath) => {
      const params = `?ap=action_type_email_action`;
      // If user is currently on a campaign, link them to the first email on said campaign
      if (currentPath?.includes('workflow/action') === true) {
        return `${currentPath}${params}`;
      }
      if (setupGuide?.sample_campaign_id == null) {
        return `campaigns/`;
      }
      const url = `campaigns/${setupGuide?.sample_campaign_id}/setup/workflow/actions${params}`;
      return url;
    },
  }),
  createStep({
    id: 'test-message',
    ariaLabel: 'Send a test message',
    content: 'Send a test message',
    tooltip: 'When editing an email, click Actions > Send test',
    queryFn: getSetupGuide,
    completion: (data) => {
      if (data == null) {
        return 0;
      }
      if (
        data?.setup_guide.sent_test_message_at != null ||
        data?.setup_guide.campaign_rocket_sent_test_message_at != null
      ) {
        return 1;
      }
      return 0;
    },
    modelId: 'campaign_rocket_sent_test_message_at',
    href: (setupGuide, currentPath) => {
      const params = `?ap=action_type_email_action`;
      if (currentPath?.includes('workflow/action') === true) {
        return `${currentPath}${params}`;
      }

      if (setupGuide?.sample_campaign_id == null) {
        return `campaigns/`;
      }

      const url = `campaigns/${setupGuide?.sample_campaign_id}/setup/workflow/actions`;
      return url;
    },
  }),
] as const;
